import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { secure } from "@calaosoft/osapp-common/rxjs/operators/secure";
import { ArrayHelper } from "@calaosoft/osapp-common/utils/helpers/arrayHelper";
import { PathHelper } from "@calaosoft/osapp-common/utils/helpers/path-helper";
import { StringHelper } from "@calaosoft/osapp-common/utils/helpers/stringHelper";
import { Observable, combineLatest, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { DocExplorerComponent } from "../doc-explorer/doc-explorer.component";

@Component({
	selector: "calao-doc-explorer-slide",
	templateUrl: "./doc-explorer-slide.component.html",
	styleUrls: ["./doc-explorer-slide.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DocExplorerSlideComponent extends DocExplorerComponent implements OnDestroy, OnInit {
	//#region PROPERTIES

	public readonly canDisplayFabButton$: Observable<boolean> = this.getCanDisplayFabButton$();

	//#endregion

	//#region METHODS

	public ngOnInit(): void {
		if (!this.observableRootPath.value)
			void this.initRootPathAsync();
		else if (!this.observableCurrentPath.value)
			this.observableCurrentPath.value = this.observableRootPath.value ?? "";
	}

	private async initRootPathAsync(): Promise<void> {
		const laPaths: string[] = await this.isvcEntities.getEntityDocumentPathsAsync(this.isvcEntityLink.currentEntity);
		const lsRootPath: string | undefined = ArrayHelper.getFirstElement(laPaths);
		this.observableRootPath.value = lsRootPath ? PathHelper.parsePath(lsRootPath) : undefined;
		if (!this.observableCurrentPath.value)
			this.observableCurrentPath.value = this.observableRootPath.value ?? "";
	}

	private getCanDisplayFabButton$(): Observable<boolean> {
		return combineLatest([
			this.observableCurrentPath.value$,
			this.isvcDocExplorerDocuments.observableIsInit.value$
		]).pipe(
			switchMap(([psPath, pbIsInit]: [string | undefined, boolean | undefined]) =>
				psPath && pbIsInit ? this.isvcDocExplorerDocuments.canCreateInFolderOrSubFolders$(psPath) : of(false)
			),
			secure(this)
		);
	}

	public override onPathChanged(psPath: string): void {
		super.onPathChanged(psPath);

		if (!StringHelper.isBlank(psPath)) this.observableCurrentPath.value = psPath;
	}

	//#endregion METHODS
}
